// 能下拉刷新的分页的setup
import { onBeforeUnmount, ref, Ref } from 'vue'
import { DevicesQuery } from '@/types/device'
import { Toast } from 'vant'
import {TrainNetworkPageQuery} from '@/types/train-netWork'

export default function refreshPageSetup(): {
  error: Ref<boolean>
  loading: Ref<boolean>
  finished: Ref<boolean>
  refreshing: Ref<boolean>
  _query: DevicesQuery
  _ts: number
  generateLoad: (func: () => Promise<void>) => () => void
  generateRefresh: (func: () => Promise<void>) => () => void
  errorDealFunc: (err: { message: string }) => void
} {
  let _ts: number = Date.now()
  const loading: Ref<boolean> = ref(false)
  const finished: Ref<boolean> = ref(false)
  const refreshing: Ref<boolean> = ref(false)
  const error: Ref<boolean> = ref(false)
  const _query: DevicesQuery = {
    page: 0,
    per_page: 15,
  }
  onBeforeUnmount(() => {
    _ts = 0
  })
  const generateLoad = (func: () => Promise<void>): (() => void) => {
    return () => {
      _query.page++
      func && func()
    }
  }
  const generateRefresh = (func: () => Promise<void>): (() => void) => {
    return () => {
      _ts = Date.now()
      if (!error.value) {
        finished.value = true
        loading.value = true
      } else {
        error.value = false
      }
      _query.page = 1
      func && func()
    }
  }
  const errorDealFunc = (err: { message: string }): void => {
    loading.value = false
    refreshing.value = false
    _query.page--
    error.value = true
    let message: string = err.message
    if (message === 'Network Error') {
      // 重写axios默认错误
      message = '网络连接异常，请稍后再试'
    }
    Toast(message)
    console.error(message)
  }
  return {
    error,
    loading,
    finished,
    refreshing,
    _query,
    _ts,
    generateLoad,
    generateRefresh,
    errorDealFunc,
  }
}


export  function refreshTrainPageSetup(): {
  error: Ref<boolean>
  loading: Ref<boolean>
  finished: Ref<boolean>
  refreshing: Ref<boolean>
  _query: TrainNetworkPageQuery
  _ts: number
  generateLoad: (func: () => Promise<void>) => () => void
  generateRefresh: (func: () => Promise<void>) => () => void
  errorDealFunc: (err: { message: string }) => void
} {
  let _ts: number = Date.now()
  const loading: Ref<boolean> = ref(false)
  const finished: Ref<boolean> = ref(false)
  const refreshing: Ref<boolean> = ref(false)
  const error: Ref<boolean> = ref(false)
  const _query: TrainNetworkPageQuery = {
    page: 0,
    per_page: 15,
  }
  onBeforeUnmount(() => {
    _ts = 0
  })
  const generateLoad = (func: () => Promise<void>): (() => void) => {
    return () => {
      _query.page++
      func && func()
    }
  }
  const generateRefresh = (func: () => Promise<void>): (() => void) => {
    return () => {
      _ts = Date.now()
      if (!error.value) {
        finished.value = true
        loading.value = true
      } else {
        error.value = false
      }
      _query.page = 1
      func && func()
    }
  }
  const errorDealFunc = (err: { message: string }): void => {
    loading.value = false
    refreshing.value = false
    _query.page--
    error.value = true
    let message: string = err.message
    if (message === 'Network Error') {
      // 重写axios默认错误
      message = '网络连接异常，请稍后再试'
    }
    Toast(message)
    console.error(message)
  }
  return {
    error,
    loading,
    finished,
    refreshing,
    _query,
    _ts,
    generateLoad,
    generateRefresh,
    errorDealFunc,
  }
}